"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textAreaTheme = void 0;
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const textAreaTheme = (0, _sdsThemeInternal.themed)({
  // use with getStylingState in formInputTheme
  resizerOffset: {
    bottom: {
      rest: {
        "lodestar-light": "-2.25px",
        "ursa-light": "-2.25px"
      },
      error: {
        "lodestar-light": "-2.25px",
        "ursa-light": "-3.25px"
      },
      active: {
        "lodestar-light": "-2.25px",
        "ursa-light": "-3.25px"
      }
    },
    right: {
      rest: {
        "lodestar-light": "2px",
        "ursa-light": "2px"
      },
      error: {
        "lodestar-light": "2px",
        "ursa-light": "1px"
      },
      active: {
        "lodestar-light": "2px",
        "ursa-light": "1px"
      }
    }
  },
  resizerColor: {
    "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--stronger"),
    "ursa-light": (0, _designTokensReact.color)("color--background--neutral--strongest")
  }
});
exports.textAreaTheme = textAreaTheme;
//# sourceMappingURL=textAreaTheme.js.map